export enum TestRunConfigModalStep {
    Main, // Top-level form
    Prompt, // Select prompt
    Model, // Select model
}
